// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"135":"59a2f530","419":"d640eecc","525":"5db5b034","660":"4d39be45","671":"037eaa4e","765":"69968ced","844":"3919cce0"}[chunkId] + ".css";
};